<template>
    <div class="points-detail">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <div class='herder'>
                <span class='back'
                      @click="clickBack"><i></i></span>
                <p>积分明细</p>
            </div>
            <div class="main"
                 ref="myScroll">
                <div class="tips">学生每完成一次作业，老师即可获得1积分</div>
                <div class="point-list"
                     v-if="dataList.length">
                    <div class="item"
                         v-for="(item,index) in dataList"
                         @click="getScoreDetail"
                         :key="index">
                        <div class="data">
                            <span>{{item.date}}</span>
                        </div>
                        <ul>
                            <li v-for="(item2,index2) in item.tmp_list"
                                :key="index2">
                                <div class="unit-name"><span :class="item2.sid==21?'':item2.sid==11?'orange':'green'">{{item2.sid==11?'书':item2.sid==21?'数':'语'}}</span> {{item2.unit_name}}</div>
                                <span class="point">+{{item2.add_score}}积分</span>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </template>
    </div>
</template>

<script>
import loadings from "COMPONENTS/base/loadingS.vue";
import noResouse from "COMPONENTS/noResouse.vue";
export default {
    components: {
        loadings, noResouse
    },
    data () {
        return {
            loading: false,
            dataList: [],
            page_no: 1,
            //每页的条数，一天是一天
            page_size: 10,
        }
    },
    mounted () {
        this.getScoreDetail();
        window.addEventListener("scroll", this.scrollBottom);
    },
    methods: {
        clickBack () {
            this.$router.go(-1);
        },
        //获取积分明细
        getScoreDetail () {
            this.isLoading = true
            let url = API_URL_HD_API + '/winter2023/tea/get_score_detail/'
            let params = {
                page_no: this.page_no, // 页码 
                page_size: this.page_size  //每页几条
            }
            this.$http.post(url, params).then(res => {
                if (res.data.response === 'ok') {
                    this.isLoading = false
                    if (!res.data.data.length) {
                        layer.tips('已加载全部内容')
                    } else {
                        this.page_no++;
                    }
                    this.dataList = this.dataList.concat(res.data.data);
                }
            })
        },

        scrollBottom () {
            //加载更多
            var scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight =
                document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight =
                document.documentElement.scrollHeight || document.body.scrollHeight;
            //滚动条到底部的条件
            if (scrollTop + windowHeight == scrollHeight && scrollTop > 100) {
                //写后台加载数据的函数
                this.getScoreDetail();
            }
        },
    },
    destroyed () {
        window.removeEventListener("scroll", this.scrollBottom);
    }
}
</script>

<style lang="scss" scoped>
.points-detail {
    background: #eb0000;
    min-height: 100vh;
    padding-top: 96px / $ppr;
}
.herder {
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    background: #ffffff;
    position: fixed;
    z-index: 9;
    top: 0;
    left: 0;
    width: 100%;
    .back {
        width: 64px / $ppr;
        height: 96px / $ppr;
        display: inline-block;
        position: absolute;
        text-align: center;
        top: 0;
        left: 0;
        z-index: 3;
        i {
            width: 16px / $ppr;
            height: 30px / $ppr;
            background: url("./img/icon_img_23.png") no-repeat;
            background-size: 100% 100%;
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    p {
        width: 100%;
        text-align: center;
        height: 90px / $ppr;
        display: inline-block;
        font-size: 36px / $ppr;
        color: #333333;
    }
}

.main {
    .tips {
        text-align: center;
        font-size: 24px / $ppr;
        color: #ffe2b7;
        padding: 25px / $ppr 0;
    }
    .point-list {
        padding: 35px / $ppr 56px / $ppr 1px / $ppr;
        .item {
            background: url("./img/border-bg-center.png") repeat-y;
            background-size: 100% 100%;
            padding: 13px / $ppr 45px / $ppr;
            color: #ffe2b7;
            position: relative;
            margin-bottom: 70px / $ppr;
            &:before,
            &:after {
                content: "";
                display: block;
                width: 100%;
                height: 25px / $ppr;
                position: absolute;
                left: 0;
            }
            &:before {
                content: "";
                background: #eb0000 url("./img/border-bg-top.png") no-repeat;
                background-size: 100% 100%;
                top: 0;
            }
            &:after {
                content: "";
                background: #eb0000 url("./img/border-bg-bottom.png") no-repeat;
                background-size: 100% 100%;
                bottom: 0;
            }
            .data {
                position: absolute;
                width: 100%;
                left: 0;
                top: -21px / $ppr;
                text-align: center;
                span {
                    display: inline-block;
                    background: #ffca85;
                    width: 212px / $ppr;
                    font-size: 24px / $ppr;
                    line-height: 42px / $ppr;
                    color: #ac0000;
                    border-radius: 42px / $ppr;
                    font-weight: bold;
                }
            }
            ul {
                li {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-weight: bold;
                    padding: 29px / $ppr 0;
                    border-top: 1px solid #d54638;
                    &:first-child {
                        border-top: 0;
                    }
                    .unit-name {
                        font-size: 30px / $ppr;
                        span {
                            display: inline-block;
                            width: 40px / $ppr;
                            height: 40px / $ppr;
                            border-radius: 10px / $ppr;
                            background: #fff;
                            text-align: center;
                            line-height: 46px / $ppr;
                            font-size: 24px / $ppr;
                            color: #01a2ff;
                            vertical-align: middle;
                            margin-top: -2px / $ppr;
                            font-weight: bold;
                        }
                        .green {
                            color: #04c644;
                        }
                        .orange {
                            color: #eb8500;
                        }
                    }
                    .point {
                        font-size: 32px / $ppr;
                    }
                }
            }
        }
    }
}
</style>